export default "__VITE_ASSET__DygDp8QD__"